<template>
<div :class="`ee-select-box ee-select-box--${size}`" @mouseleave="visible = false" :style="{width: `${width}px`}">
  <div @click="visible = !visible" class="ee-select-box__toggle">
    {{typeof current === 'string' ? current : current.text}}<i class="text-icon icon-yzm"></i>
  </div>
  <ul v-show="visible" class="ee-select-box__content">
    <li
      :class="{active: value === item || value === item.value}"
      v-for="item in dataSource"
    >
      <a @click="handleSelect(item)" href="javascript:;">{{typeof item === 'string' ? item : item.text}}</a>
    </li>
  </ul>
</div>
</template>
<script>
export default {
  compName: 'ee-select-box',
  props: {
    dataSource: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      default: 'default'
    },
    width: {
      type: Number,
      default: 200
    },
    value: [Number, String]
  },
  methods: {
    handleSelect (item) {
      this.current = item
      this.$emit('input', typeof item === 'string' ? item : item.value)
      this.visible = false
    },
    initCurrent () {
      const b = this.dataSource.every(item => typeof item === 'object')
      this.current = b ? {} : ''
      if (this.value !== undefined) {
        let current = {}
        this.dataSource.every(item => {
          if (this.value === item || this.value === item.value) {
            current = item
            return false
          }
          return true
        })
        this.current = current
      }
    }
  },
  data () {
    return {
      visible: false,
      current: {}
    }
  },
  watch: {
    value () {
      this.initCurrent()
    }
  },
  created () {
    this.initCurrent()
  }
}
</script>
<style>
@import "../style/vars.css";
@component-namespace ee {
  @b select-box {
    position: relative;
    border: 1px solid #eee;
    @e toggle {
      position: relative;
      padding: 0 20px 0 5px;
      width: 100%;
      height: 100%;
      .text-icon {
        position: absolute;
        top: 50%;
        right: 6px;
        transform: translateY(-50%);
        color: #28a7e1;
      }
    }
    @e content {
      position: absolute;
      left: 0;
      top: 100%;
      padding: 10px;
      border: 1px solid #eee;
      z-index: 9;
      background-color: #fff;
      li {
        float: left;
        width: 80px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.active,
        &:hover {
          color: var(--main-color);
        }
        a {
          color: inherit;
        }
      }
    }
    @m xlarge {
      height: 54px;
      line-height: 54px;
    }
    @m large {
      height: 48px;
      line-height: 48px;
    }
    @m middle {
      height: 42px;
      line-height: 42px;
    }
    @m default {
      height: 36px;
      line-height: 36px;
    }
    @m small {
      height: 30px;
      line-height: 30px;
    }
    @m tiny {
      height: 24px;
      line-height: 24px;
    }
    @m mini {
      height: 18px;
      line-height: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/packages/select/SelectBox.vue?3ffcfd36